import { render } from "./Prijzen.vue?vue&type=template&id=381eff2a&scoped=true"
import script from "./Prijzen.vue?vue&type=script&lang=js"
export * from "./Prijzen.vue?vue&type=script&lang=js"

import "./Prijzen.vue?vue&type=style&index=0&id=381eff2a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381eff2a"]])

export default __exports__